export default {
      id: "ic_sort_new-usage",
      viewBox: "0 0 10 10",
      url: "/" + "images/icons.3.109.2.svg#ic_sort_new-usage",
      toString: function () {
        return this.url;
      }
    }